/* eslint-disable react/no-danger */
import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { Box, Button } from '@resurs/midas-react'
import { midas } from '@resurs/midas'
import moment from 'moment'
import { useToggle } from '../../../util/utility-hooks'
import { classNames, getSanitizedHTML } from '../../../util/helpers'
import { getText } from '../../TextLabels'
import { prettyPrintDateTime } from '../../../util/dateUtils'
import {
  ArticleTypeIcon,
  ArticleTypeKeys,
  ArticleTypeValues,
} from '../../../pages/News/constants'
import styles from './styles.module.scss'

const getArticleTypeStyleClassFromTypeValue = type => {
  switch (type) {
    case ArticleTypeKeys.WARNING:
      return styles.warning
    case ArticleTypeKeys.INCIDENT:
      return styles.incident
    case ArticleTypeKeys.INFO:
    default:
      return styles.info
  }
}

const ArticleNotificationUI = ({ type, title, body, modified, onClose }) => {
  const [showNotification, setShowNotification] = useState(false)
  const [showMore, toggleShowMore] = useToggle(false)

  useEffect(() => {
    setShowNotification(true)
  }, [])

  const handleClose = () => {
    setShowNotification(false)
    onClose()
  }

  const articleNotificationContainerClassName = `${
    styles.articleNotificationContainer
  } ${styles[type.toLowerCase()] || ''}`

  return (
    <Box
      type={
        type.toLowerCase() === ArticleTypeValues[ArticleTypeKeys.INCIDENT]
          ? 'danger'
          : type.toLowerCase()
      }
    >
      <div
        className={classNames(
          articleNotificationContainerClassName,
          showNotification && styles.show,
          getArticleTypeStyleClassFromTypeValue(type),
        )}
      >
        <div className={styles.mainRow}>
          <div className={styles.iconColumn}>
            <i
              className={classNames(midas.icon, midas[ArticleTypeIcon[type]])}
            />
          </div>
          <div className={styles.titleColumn}>{title}</div>
          <div className={styles.moreInfoBodyColumn}>
            <Button
              id="toggle"
              type="link"
              size="small"
              onClick={toggleShowMore}
            >
              {showMore
                ? getText('default.showLess')
                : getText('default.showMore')}
            </Button>
          </div>
          <div className={styles.closeColumn}>
            <button
              aria-label="Close"
              type="button"
              className={classNames(midas.button, midas.buttonClear)}
              onClick={handleClose}
            />
          </div>
        </div>
        <div
          className={classNames(
            styles.moreInfoRow,
            showMore && styles.moreInfoRowShow,
          )}
        >
          <div
            className={styles.moreInfoBodyColumn}
            dangerouslySetInnerHTML={{
              __html: getSanitizedHTML(body),
            }}
          />
          <div
            className={styles.moreInfoModifiedColumn}
            title={prettyPrintDateTime(modified)}
          >
            {moment(modified).fromNow()}
          </div>
        </div>
      </div>
    </Box>
  )
}

ArticleNotificationUI.propTypes = {
  type: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  body: PropTypes.string.isRequired,
  modified: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
}

export default ArticleNotificationUI
